<template>
  <div :id="generateId('media-player')" class="media-player" :data="url" :style="mediaPlayerStyle">
    <div class="progress-call">
        <div :id="generateId('progress-bar')" class="progress-bar" :style="progressBar.style"></div>
      </div>
    <div class="buttons-call ">
                <span class="cursor-pointer" @click="playPause">
                  <media-play-icon v-if="mediaPlayer.status != statuses.PLAYING" class="media-icon"></media-play-icon>
                  <media-pause-icon v-if="mediaPlayer.status == statuses.PLAYING" class="media-icon"></media-pause-icon>
                </span>
        <span class="cursor-pointer" @click="stop">
                  <media-stop-icon class="media-icon"></media-stop-icon>
                </span>
        <span class="cursor-pointer" @click="changeVolume('up')">
                  <media-volume-up-icon class="media-icon"></media-volume-up-icon>
                </span>
        <span class="cursor-pointer" @click="changeVolume('down')">
                  <media-volume-down-icon class="media-icon"></media-volume-down-icon>
                </span>
        <span v-if="withDownload" class="cursor-pointer" @click="download">
                  <download-icon class="media-icon"></download-icon>
                </span>
      </div>
    <div v-show="infoMsg.show"
         class="absolute z-50 bg-gray-300 rounded shadow border px-1 -mt-5 text-left align-baseline text-xs whitespace-normal">
      <span>{{infoMsg.msg}}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "media-player",
  props: {
    playerId: {type: String, required: true},
    url: {type: String, required: true},
    withDownload: {type: Boolean, default: false},
  },
  data() {
    return {
      mediaPlayer: {
        id: 0,
        player: null,
        playUrl: null,
        playFilename: null,
        status: -1,
      },
      progressBar: {
        value: 0,
        style: {
          width: '0%',
          background: 'lightseagreen',
          height: '100%'
        },
        html: '',
      },
      statuses: {
        NEVER_STARTED: -1,
        STOPPED: 0,
        PLAYING: 1,
        PAUSED: 2,
        READY: 3,
        ERROR: 4,
        LOADING: 5
      },
      infoMsg: {
        show: false,
        msg: ''
      },
    }
  },
  created() {
    this.mediaPlayer = this.createAudioPlayer();
  },
  computed: {
    mediaPlayerStyle() {
      return {
        width: this.withDownload === true ? '150px' : '125px'
      }
    }
  },
  watch: {
    url: function () {
      //this.mediaPlayer = this.createAudioPlayer();
      this.progressBar.value = 0;
      this.progressBar.style.width = '0%';
      this.mediaPlayer.id = this.id;
      this.mediaPlayer.playUrl = (this.url && this.url.length > 0 && this.url !== "null") ? this.url : '';
      this.mediaPlayer.playFilename = (this.url && this.url.length > 0 && this.url !== "null") ? this.url.substring(this.url.lastIndexOf('/') + 1) : '';
      this.mediaPlayer.status = this.statuses.NEVER_STARTED;
    }
  },
  methods: {
    generateId(name) {
      return name + "-" + this.playerId;
    },
    showInfoMsg(message) {
      let $this = this;
      this.infoMsg.msg = message;
      this.infoMsg.show = true;
      setTimeout(function () {
        $this.infoMsg.show = false;
        $this.infoMsg.msg = '';
      }, 2000);
    },
    createAudioPlayer() {
      let $this = this;
      let mediaPlayer = {
        id: this.playerId,
        player: new Audio(),
        playUrl: (this.url && this.url.length > 0 && this.url !== "null") ? this.url : '',
        playFilename: (this.url && this.url.length > 0 && this.url !== "null") ? this.url.substring(this.url.lastIndexOf('/') + 1) : '',
        status: this.statuses.NEVER_STARTED,
      };
      mediaPlayer.player.addEventListener('error', function (event) {
        $this.showInfoMsg("No file to play");
        $this.mediaPlayer.status = $this.statuses.ERROR;
      });
      mediaPlayer.player.addEventListener('play', function (event) {
        $this.mediaPlayer.status = $this.statuses.PLAYING;
      });
      mediaPlayer.player.addEventListener('playing', function (event) {
        $this.mediaPlayer.status = $this.statuses.PLAYING;
        $this.$emit('playing', {playerId: $this.playerId, url: $this.url});
      });
      mediaPlayer.player.addEventListener('ended', function (event) {
        $this.mediaPlayer.status = $this.statuses.STOPPED;
        $this.$emit('ended', {playerId: $this.playerId, url: $this.url});
      });
      mediaPlayer.player.addEventListener('pause', function (event) {
        if ($this.mediaPlayer.player.currentTime === 0) {
          $this.mediaPlayer.status = $this.statuses.STOPPED;
          $this.$emit('stopped', {playerId: $this.playerId, url: $this.url});
        } else {
          $this.mediaPlayer.status = $this.statuses.PAUSED;
          $this.$emit('paused', {playerId: $this.playerId, url: $this.url});
        }
      });
      mediaPlayer.player.addEventListener('timeupdate', function (event) {
        let percentage = Math.floor((100 / $this.mediaPlayer.player.duration) * $this.mediaPlayer.player.currentTime);
        $this.progressBar.value = parseInt(percentage).toFixed(1);
        $this.progressBar.style.width = percentage + '%';
        $this.progressBar.HTML = percentage + '% played';
      });
      console.log("Media player created");
      return mediaPlayer;
    },
    loadMediaPlayer() {
      console.log("Loading Media player...");
      if (this.mediaPlayer.playUrl.length > 0) {
        let $this = this;
        this.mediaPlayer.player.setAttribute('src', this.mediaPlayer.playUrl);
        this.mediaPlayer.player.addEventListener('loadeddata', function (event) {
          if ($this.mediaPlayer.player.readyState === 4) {
            $this.mediaPlayer.status = $this.statuses.READY;
            $this.playPause();
          }
        });
      } else {
        this.mediaPlayer.status = this.statuses.ERROR;
        this.showInfoMsg("No file to play");
      }
    },
    playPause() {
      if (this.mediaPlayer.status === this.statuses.NEVER_STARTED ||
          this.mediaPlayer.status === this.statuses.ERROR
      ) {
        this.mediaPlayer.status = this.statuses.LOADING;
        this.showInfoMsg("Loading file...");
        this.loadMediaPlayer();
      }
      // Play
      if (this.mediaPlayer.status === this.statuses.PAUSED ||
          this.mediaPlayer.status === this.statuses.STOPPED ||
          this.mediaPlayer.status === this.statuses.READY ||
          this.mediaPlayer.status === this.statuses.LOADING
      ) {
        this.mediaPlayer.player.play();
        // Pause
      } else if (this.mediaPlayer.status === this.statuses.PLAYING) {
        this.mediaPlayer.player.pause();
      }
    },
    stop() {
      //little hack to trigger the onpause event for the flow: play->pause->stop. When is already paused, another call to pause
      //does not trigger the eventhandler so the status and the emit is never thrown.
      // This will play it and pause it quickly, the user should not hear anything, to trigger the onpause eventhandler
      this.mediaPlayer.player.play();
      this.mediaPlayer.player.pause();
      this.mediaPlayer.player.currentTime = 0;
    },
    changeVolume(direction) {
      let currentVol = this.mediaPlayer.player.volume;
      let newVol = 0;
      if (direction === 'up') {
        newVol = currentVol * 1.25;
        newVol = (newVol > 1) ? 1 : newVol;
      } else {
        newVol = currentVol / 1.25;
        newVol = (newVol < 0) ? 0 : newVol;
      }
      this.mediaPlayer.player.volume = newVol;
    },
    download() {
      window.open(this.mediaPlayer.playUrl, "_blank");
    },
  }
}
</script>

<style scoped>
.media-player {
  position: relative;
  height: 37px;
  padding: 5px;
  text-align: center;
}

.media-player div.progress-call {
  position: absolute;
  top: 0px;
  left: 0px;
  border: 1px gray solid;
  width: 100%;
  height: 34px;
  border-radius: 6px;
}

.media-player div.buttons-call {
  position: absolute;
}

.media-player div.buttons-call .media-icon {
  height: 24px;
  width: 28px;
  border-radius: 3px;
  box-shadow: none !important;
  background-color: #fff !important;
  border: 1px solid #999;
  color: #337ab7;
  float: left;
  padding: 4px;
}
</style>